import { render, staticRenderFns } from "./produceAnalyse.vue?vue&type=template&id=564b2ca9&scoped=true&"
import script from "./produceAnalyse.vue?vue&type=script&lang=js&"
export * from "./produceAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./produceAnalyse.vue?vue&type=style&index=0&id=564b2ca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b2ca9",
  null
  
)

export default component.exports